'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var theme_theme = require('./theme.js');
var theme_variables = require('./variables.js');
var createTheme$1 = require('../createTheme-3e29ac1c.js');
require('./overrides/index.js');
require('../accordion-2397c51d.js');
require('../variables-1eb6495a.js');
require('../accordion-details-0d01e961.js');
require('../accordion-summary-45b788cd.js');
require('../app-bar-93f90640.js');
require('../autocomplete-14341857.js');
require('../colorManipulator-abc93889.js');
require('../badge-7bf62cb8.js');
require('../button-5f59739a.js');
require('../toggle-button-b8dc039c.js');
require('../toggle-button-group-06614a61.js');
require('../button-group-8e4ef3b2.js');
require('../checkbox-968c1a4d.js');
require('../chip-ebf5c0e6.js');
require('../dialog-actions-5bdcc337.js');
require('../dialog-content-1aceacce.js');
require('../dialog-content-text-6a7df706.js');
require('../dialog-title-942c98b2.js');
require('../divider-1a75a085.js');
require('../form-control-label-1279e5c3.js');
require('../form-label-f5abd807.js');
require('../form-helper-text-5b194beb.js');
require('../icon-button-cfab2859.js');
require('../input-adornment-78aa29bd.js');
require('../input-base-fd0f3e6e.js');
require('../input-label-ffea38fe.js');
require('../link-7fbedce8.js');
require('../list-6e7a4033.js');
require('../list-item-3c92df0c.js');
require('../index-c6190cd6.js');
require('../list-item-icon-6f4247d5.js');
require('../list-item-text-e19f4c72.js');
require('../menu-4675ead8.js');
require('../menu-item-bee40acc.js');
require('../outlined-input-fc75a66c.js');
require('../pickers-day-0d29ac09.js');
require('../popover-f7340ac9.js');
require('../radio-697959a0.js');
require('../select-26805ec5.js');
require('../slider-f55b6709.js');
require('../snackbar-content-eeeb8a08.js');
require('../switch-23c2d70a.js');
require('../tab-77dd2fef.js');
require('../tabs-99124ac5.js');
require('../toolbar-4b2c6c32.js');
require('../tooltip-9d3d77e5.js');
require('../table-cell-87a0d022.js');
require('../table-container-10cf3ac1.js');
require('../table-head-ffdb5d82.js');
require('../table-row-387bc498.js');
require('../table-sort-label-ea697e35.js');
require('../table-f1ed3b35.js');
require('../card-action-area-bdb1666b.js');
require('../list-subheader-32f5e9a2.js');
require('./palette/index.js');
require('./palette/light.js');
require('./props.js');
require('@qlik-trial/sprout/icons/ArrowDown');
require('@qlik-trial/sprout/icons/Close');
require('./components/CheckboxIcon.js');
require('./components/IconWrapper.js');
require('./components/CheckedCheckboxIcon.js');
require('./components/IndeterminateCheckboxIcon.js');
require('./components/RadioIcon.js');
require('./components/CheckedRadioIcon.js');
require('./components/SortIcon.js');

const createTheme = (variant = "light") => createTheme$1.createTheme(theme_theme(variant));
const createThemeOptions = (variant = "light") => theme_theme(variant);

exports.COLORS = theme_variables.COLORS;
exports.createTheme = createTheme;
exports.createThemeOptions = createThemeOptions;
